import template from './_message-card.pug'
import iconoRojo from 'assets/images/ico-message-rojo.svg'
import iconoCeleste from 'assets/images/ico-message-celeste.svg'
import iconoVerde from 'assets/images/ico-message-verde.svg'

// @vue/component
export default {
  template: template(),

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  computed: {
    municipality() {
      return this.$store.state.municipality
    },

    timeZone() {
      return this.municipality.time_zone
    },

    messageId() {
      return `message-${this.message.id}`
    },

    truncatedTitle() {
      return _.truncate(this.message.title, {length: 32})
    },

    momentDate() {
      if (this.timeZone) {
        return moment(this.message.created_at).tz(this.timeZone)
      }
      return moment(this.message.created_at)
    },

    solvedClass() {
      return {'text-solved': this.stateSolved}
    },

    stateSolved() {
      return ( (this.message.state === 'solved') || (this.message.state == "pending" && this.message.status_chat == true))
    }
  },

  methods: {
    emitClick() {
      this.$emit('click')
    },
    colorIco(){
      if((this.message.state == "pending" && this.message.status_chat == true) || (this.message.state == "solved") ){
        return   iconoVerde 
      }else if(this.message.state == "pending"){
        return iconoCeleste 
      }else{
        return iconoRojo
      }
      
      
    }
  }
}
